export const SUPPORT = {
    HELPTOPIC: '1',
    PRIORITY: '1',
};
